import './StaticPages.css'

export default function TermsPage(){
  return (
    <main className="static-page page">
      <div className="container">
        <h1>Terms & Conditions</h1>
        <p>These terms govern your use of the Healthy Living Blog static website. Use of the site constitutes acceptance of these terms.</p>
        <h2>Use of Content</h2>
        <p>All content is for informational purposes. Reuse requires permission.</p>
        <h2>Liability</h2>
        <p>We are not responsible for actions taken based on the information provided on the site.</p>
      </div>
    </main>
  )
}
